export default __webpack_public_path__ + "static/gitkraken_repo_main-8ee2a9ad86d6c3ff9243b6a05c77c6df.png";